import './style.scss';
interface Props {
	className?: string;
}

export const PopularSkeleton: React.FC<Props> = (props) => (
	<svg viewBox="0 0 296 215" xmlns="http://www.w3.org/2000/svg" className="popular__skeleton" {...props}>
		<rect width="296" height="215" rx="8" />
		<rect x="12" y="20" width="86" height="15" rx="7.5" fill="#E6E6E6" />
		<circle cx="22" cy="62" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="62" r="8" fill="#E6E6E6" />
		<rect x="62" y="56" width="86" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="56" width="10" height="12" rx="5" fill="#E6E6E6" />
		<circle cx="22" cy="94" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="94" r="8" fill="#E6E6E6" />
		<rect x="62" y="88" width="86" height="12" rx="6" fill="#E6E6E6" />
		<rect x="270" y="88" width="14" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="126" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="126" r="8" fill="#E6E6E6" />
		<rect x="62" y="120" width="111" height="12" rx="6" fill="#E6E6E6" />
		<rect x="263" y="120" width="21" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="158" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="158" r="8" fill="#E6E6E6" />
		<rect x="62" y="152" width="76" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="152" width="10" height="12" rx="5" fill="#E6E6E6" />
		<circle cx="22" cy="190" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="190" r="8" fill="#E6E6E6" />
		<rect x="62" y="184" width="110" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="184" width="10" height="12" rx="5" fill="#E6E6E6" />
	</svg>
);
